const getters = {};

export default getters;



// WEBPACK FOOTER //
// ./website/store/getters.js